import React from "react";
import { useInfoValue } from "../Contexts/InfoContext";

export const TemplateTwo = () => {
  const { infoData } = useInfoValue();

  return (
    <table
      cellPadding="0"
      cellSpacing="0"
      style={{
        verticalSpacing: "-webkit-baseline-middle",
        fontSize: "medium",
        fontFamily: "Arial",
        minWidth: "450px",
      }}
    >
      <tbody>
        <tr>
          <td style={{ textAlign: "center" }}>
            {infoData.portrait && (
              <img
                width="130"
                src={
                  infoData.portrait
                    ? infoData.portrait
                    : "https://i.pravatar.cc/?img=49"
                }
                alt="Potrait"
                role="presentation"
                style={{ maxWidth: "130px", display: "inline-block" }}
              />
            )}
          </td>
        </tr>
        <tr>
          <td height="10"></td>
        </tr>
        <tr style={{ textAlign: "center" }}>
          <td>
            {infoData.firstName && infoData.lastName && (
              <h3
                color="#000000"
                style={{
                  margin: "0px",
                  fontSize: "18px",
                  color: "rgb(0, 0, 0)",
                }}
              >
                <span>{infoData.firstName}</span>
                <span>&nbsp;</span>
                <span>{infoData.lastName}</span>
              </h3>
            )}

            {infoData.jobTitle && (
              <p
                color="#000000"
                fontSize="medium"
                style={{
                  margin: "0px",
                  color: "rgb(0, 0, 0)",
                  fontSize: "14px",
                  lineHeight: "22px",
                }}
              >
                <span>{infoData.jobTitle}</span>
              </p>
            )}
            {(infoData.department || infoData.companyName) && (
              <p
                color="#000000"
                fontSize="medium"
                style={{
                  margin: "0px",
                  fontWeight: "500",
                  color: "rgb(0, 0, 0)",
                  fontSize: "14px",
                  lineHeight: "22px",
                }}
              >
                <span>{infoData.department}</span>
                {infoData.department && infoData.companyName && (
                  <span>&nbsp;|&nbsp;</span>
                )}
                <span>{infoData.companyName}</span>
              </p>
            )}
          </td>
        </tr>
        <tr>
          <td>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{
                verticalSpacing: "-webkit-baseline-middle",
                fontSize: "medium",
                fontFamily: "Arial",
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <td height="30"></td>
                </tr>
                <tr>
                  <td
                    height="1"
                    color={infoData.accentColor}
                    direction="horizontal"
                    style={{
                      width: "100%",
                      borderBottom: `1px solid ${infoData.accentColor}`,
                      borderLeft: "none",
                      display: "block",
                    }}
                  ></td>
                </tr>
                <tr>
                  <td height="30"></td>
                </tr>
              </tbody>
            </table>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{
                verticalSpacing: "-webkit-baseline-middle",
                fontSize: "medium",
                fontFamily: "Arial",
                width: "100%",
              }}
            >
              <tbody>
                <tr style={{ verticalSpacing: "middle" }}>
                  <td>
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      style={{
                        verticalSpacing: "-webkit-baseline-middle",
                        fontSize: "medium",
                        fontFamily: "Arial",
                      }}
                    >
                      <tbody>
                        {(infoData.officePhone || infoData.mobilePhone) && (
                          <tr height="25" style={{ verticalSpacing: "middle" }}>
                            <td
                              width="30"
                              style={{ verticalSpacing: "middle" }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                style={{
                                  verticalSpacing: "-webkit-baseline-middle",
                                  fontSize: "medium",
                                  fontFamily: "Arial",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ verticalSpacing: "bottom" }}>
                                      <span
                                        width="11"
                                        color={infoData.accentColor}
                                        style={{
                                          display: "block",
                                          backgroundColor: infoData.accentColor,
                                        }}
                                      >
                                        <img
                                          width="12"
                                          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/phone-icon-2x.png"
                                          color={infoData.accentColor}
                                          alt="Phone icon"
                                          style={{
                                            display: "block",
                                            backgroundColor:
                                              infoData.accentColor,
                                          }}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{ padding: "0px", color: "rgb(0, 0, 0)" }}
                            >
                              <a
                                href={`tel:${infoData.officePhone}`}
                                color="#000000"
                                style={{
                                  textDecoration: "none",
                                  color: "rgb(0, 0, 0)",
                                  fontSize: "12px",
                                }}
                              >
                                <span>{infoData.officePhone}</span>
                              </a>{" "}
                              |{" "}
                              <a
                                href={`tel:${infoData.mobilePhone}`}
                                color="#000000"
                                style={{
                                  textDecoration: "none",
                                  color: "rgb(0, 0, 0)",
                                  fontSize: "12px",
                                }}
                              >
                                <span>{infoData.mobilePhone}</span>
                              </a>
                            </td>
                          </tr>
                        )}
                        {infoData.emailAddress && (
                          <tr height="25" style={{ verticalSpacing: "middle" }}>
                            <td
                              width="30"
                              style={{ verticalSpacing: "middle" }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                style={{
                                  verticalSpacing: "-webkit-baseline-middle",
                                  fontSize: "medium",
                                  fontFamily: "Arial",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ verticalSpacing: "bottom" }}>
                                      <span
                                        width="11"
                                        color={infoData.accentColor}
                                        style={{
                                          display: "block",
                                          backgroundColor: infoData.accentColor,
                                        }}
                                      >
                                        <img
                                          width="12"
                                          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/email-icon-2x.png"
                                          color={infoData.accentColor}
                                          alt="Email icon"
                                          style={{
                                            display: "block",
                                            backgroundColor:
                                              infoData.accentColor,
                                          }}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <a
                                href={`mailto:${infoData.emailAddress}`}
                                color="#000000"
                                style={{
                                  textDecoration: "none",
                                  color: "rgb(0, 0, 0)",
                                  fontSize: "12px",
                                }}
                              >
                                <span>{infoData.emailAddress}</span>
                              </a>
                            </td>
                          </tr>
                        )}
                        {infoData.websiteUrl && (
                          <tr height="25" style={{ verticalSpacing: "middle" }}>
                            <td
                              width="30"
                              style={{ verticalSpacing: "middle" }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                style={{
                                  verticalSpacing: "-webkit-baseline-middle",
                                  fontSize: "medium",
                                  fontFamily: "Arial",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ verticalSpacing: "bottom" }}>
                                      <span
                                        width="11"
                                        color={infoData.accentColor}
                                        style={{
                                          display: "block",
                                          backgroundColor: infoData.accentColor,
                                        }}
                                      >
                                        <img
                                          width="12"
                                          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/link-icon-2x.png"
                                          color={infoData.accentColor}
                                          alt="Website URL icon"
                                          style={{
                                            display: "block",
                                            backgroundColor:
                                              infoData.accentColor,
                                          }}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <a
                                href={`https://${infoData.websiteUrl}`}
                                color="#000000"
                                style={{
                                  textDecoration: "none",
                                  color: "rgb(0, 0, 0)",
                                  fontSize: "12px",
                                }}
                              >
                                <span>{infoData.websiteUrl}</span>
                              </a>
                            </td>
                          </tr>
                        )}
                        {infoData.address && (
                          <tr height="25" style={{ verticalSpacing: "middle" }}>
                            <td
                              width="30"
                              style={{ verticalSpacing: "middle" }}
                            >
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                style={{
                                  verticalSpacing: "-webkit-baseline-middle",
                                  fontSize: "medium",
                                  fontFamily: "Arial",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <td style={{ verticalSpacing: "bottom" }}>
                                      <span
                                        width="11"
                                        color={infoData.accentColor}
                                        style={{
                                          display: "block",
                                          backgroundColor: infoData.accentColor,
                                        }}
                                      >
                                        <img
                                          width="12"
                                          src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/address-icon-2x.png"
                                          color={infoData.accentColor}
                                          alt="Address icon"
                                          style={{
                                            display: "block",
                                            backgroundColor:
                                              infoData.accentColor,
                                          }}
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <span
                                color="#000000"
                                style={{
                                  fontSize: "12px",
                                  color: "rgb(0, 0, 0)",
                                }}
                              >
                                <span>{infoData.address}</span>
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </td>
                  <td width="15"></td>
                  <td style={{ textAlign: "right" }}>
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      style={{
                        verticalSpacing: "-webkit-baseline-middle",
                        fontSize: "medium",
                        fontFamily: "Arial",
                        width: "100%",
                      }}
                    >
                      <tbody>
                        {infoData.logo && (
                          <React.Fragment>
                            <tr>
                              <td>
                                <img
                                  width="130"
                                  src={
                                    infoData.logo
                                      ? infoData.logo
                                      : "https://pngimage.net/wp-content/uploads/2018/06/logo-placeholder-png-3.png"
                                  }
                                  alt="Logo"
                                  role="presentation"
                                  style={{
                                    maxWidth: "130px",
                                    display: "inline-block",
                                  }}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td height="10"></td>
                            </tr>
                          </React.Fragment>
                        )}
                        {(infoData.socialFacebook ||
                          infoData.socialInstagram ||
                          infoData.socialLinkedin ||
                          infoData.socialTwitter) && (
                          <tr>
                            <td>
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                style={{
                                  verticalSpacing: "-webkit-baseline-middle",
                                  fontSize: "medium",
                                  fontFamily: "Arial",
                                  display: "inline-block",
                                }}
                              >
                                <tbody>
                                  <tr style={{ textAlign: "right" }}>
                                    {infoData.socialFacebook && (
                                      <React.Fragment>
                                        <td>
                                          <a
                                            href={`https://${infoData.socialFacebook}`}
                                            color={infoData.socialColor}
                                            style={{
                                              display: "inline-block",
                                              padding: "0px",
                                              backgroundColor:
                                                infoData.socialColor,
                                            }}
                                          >
                                            <img
                                              height="24"
                                              src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/facebook-icon-2x.png"
                                              alt="facebook"
                                              color={infoData.socialColor}
                                              style={{
                                                backgroundColor:
                                                  infoData.socialColor,
                                                maxWidth: "135px",
                                                display: "block",
                                              }}
                                            />
                                          </a>
                                        </td>
                                        <td width="5"></td>
                                      </React.Fragment>
                                    )}
                                    {infoData.socialTwitter && (
                                      <React.Fragment>
                                        <td>
                                          <a
                                            href={`https://${infoData.socialTwitter}`}
                                            color={infoData.socialColor}
                                            style={{
                                              display: "inline-block",
                                              padding: "0px",
                                              backgroundColor:
                                                infoData.socialColor,
                                            }}
                                          >
                                            <img
                                              height="24"
                                              src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/twitter-icon-2x.png"
                                              alt="twitter"
                                              color={infoData.socialColor}
                                              style={{
                                                backgroundColor:
                                                  infoData.socialColor,
                                                maxWidth: "135px",
                                                display: "block",
                                              }}
                                            />
                                          </a>
                                        </td>
                                        <td width="5"></td>
                                      </React.Fragment>
                                    )}
                                    {infoData.socialLinkedin && (
                                      <React.Fragment>
                                        <td>
                                          <a
                                            href={`https://${infoData.socialLinkedin}`}
                                            color={infoData.socialColor}
                                            style={{
                                              display: "inline-block",
                                              padding: "0px",
                                              backgroundColor:
                                                infoData.socialColor,
                                            }}
                                          >
                                            <img
                                              height="24"
                                              src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/linkedin-icon-2x.png"
                                              alt="linkedin"
                                              color={infoData.socialColor}
                                              style={{
                                                backgroundColor:
                                                  infoData.socialColor,
                                                maxWidth: "135px",
                                                display: "block",
                                              }}
                                            />
                                          </a>
                                        </td>
                                        <td width="5"></td>
                                      </React.Fragment>
                                    )}
                                    {infoData.socialInstagram && (
                                      <React.Fragment>
                                        <td>
                                          <a
                                            href={`https://${infoData.socialInstagram}`}
                                            color={infoData.socialColor}
                                            style={{
                                              display: "inline-block",
                                              padding: "0px",
                                              backgroundColor:
                                                infoData.socialColor,
                                            }}
                                          >
                                            <img
                                              height="24"
                                              src="https://cdn2.hubspot.net/hubfs/53/tools/email-signature-generator/icons/instagram-icon-2x.png"
                                              alt="instagram"
                                              color={infoData.socialColor}
                                              style={{
                                                backgroundColor:
                                                  infoData.socialColor,
                                                maxWidth: "135px",
                                                display: "block",
                                              }}
                                            />
                                          </a>
                                        </td>
                                        <td width="5"></td>
                                      </React.Fragment>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              cellPadding="0"
              cellSpacing="0"
              style={{
                verticalSpacing: "-webkit-baseline-middle",
                fontSize: "medium",
                fontFamily: "Arial",
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <td height="30"></td>
                </tr>
                <tr>
                  <td
                    height="1"
                    color={infoData.accentColor}
                    direction="horizontal"
                    style={{
                      width: "100%",
                      borderBottom: `1px solid ${infoData.accentColor}`,
                      borderLeft: "none",
                      display: "block",
                    }}
                  ></td>
                </tr>
                <tr>
                  <td height="30"></td>
                </tr>
                {infoData.showReferral && (
                  <small>
                    <b>
                      <a href="https://designbuffs.com">
                        {infoData.referralText}
                      </a>
                    </b>
                  </small>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
